export default __webpack_public_path__ + "static/media/17.21cf9da4.svg";